

export class RoleGroup {
    server_role_group_id=0
    name:""
    authcount:0
    usercount:0
    authorities:[]
}
